<template>
  <div>
    <BaseDoughnutChartCard
      :labelsArray="
        getLabelsArray(jobsStats.applicantsRateCountPerRatePerDuration)
      "
      chartLabel="التقييمات المعطاة لمتقدمي المنصة"
      :dataArray="getDataArray(jobsStats.applicantsRateCountPerRatePerDuration)"
    >
      <template v-slot:title
        >التقييمات المعطاة للمتقدمين على فرص العمل</template
      >
      <template v-slot:durationSelection>
        <BaseSelect
          :items="durations"
          v-model="jobsStats.applicantsRateCountPerRateDuration"
          chips
          dense
          placeholder="المدة الزمنية"
          value="value"
        >
          <template v-slot:item="{ item }"> خلال {{ item.label }} </template>
          <template v-slot:selection="{ item }">
            خلال {{ item.label }}
          </template>
        </BaseSelect>
      </template>
    </BaseDoughnutChartCard>
  </div>
</template>

<script>
import { useStatisticsStore } from "@/modules/home/store/StatisticsStore";
import { mapActions, mapWritableState } from "pinia";
import BaseDoughnutChartCard from "../../base_statistics_cards/BaseDoughnutChartCard.vue";
import StatisticsDurations from "../../statics/StatisticsDurations";

export default {
  components: { BaseDoughnutChartCard },
  methods: {
    ...mapActions(useStatisticsStore, [
      "getLabelsArray",
      "getDataArray",
      "fetchJobsStatistics",
    ]),
  },
  watch: {
    "jobsStats.applicantsRateCountPerRateDuration": function () {
      this.fetchJobsStatistics()
        .then()
        .catch((err) => console.error(err));
    },
  },
  computed: {
    ...mapWritableState(useStatisticsStore, ["jobsStats"]),
  },
  data() {
    return {
      durations: StatisticsDurations,
    };
  },
};
</script>
